import React from "react";
import { NoPage } from "../../components/commons";

const PaymentsModule = () => {
  return <NoPage />;
};

export default PaymentsModule;
